/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';


export const touchHelp = easyPost('moon.event.dispatch', {
  api: config.MARKET_API,
});

export const exchangeCoupon = easyPost('user.account.exchange');
